import React from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { useStoreHours } from '../../utils/useStoreHours'
import './StatusPill.scss'

const c = 'status-pill'

const SleepingPanda = () => (
  <span className={`${c}__sleeper`} aria-hidden>
    <svg viewBox='0 0 120 96' className={`${c}__panda`}>
      <circle className={`${c}__ink`} cx='24' cy='28' r='16' />
      <circle className={`${c}__ink`} cx='96' cy='28' r='16' />
      <ellipse className={`${c}__face`} cx='60' cy='58' rx='46' ry='36' />
      <ellipse className={`${c}__ink`} cx='38' cy='56' rx='13' ry='11' transform='rotate(18 38 56)' />
      <ellipse className={`${c}__ink`} cx='82' cy='56' rx='13' ry='11' transform='rotate(-18 82 56)' />
      <path className={`${c}__lid`} d='M31 55q7 6 14 0M75 55q7 6 14 0' />
      <ellipse className={`${c}__ink`} cx='60' cy='68' rx='6' ry='4' />
      <circle className={`${c}__snore`} cx='60' cy='80' r='4' />
    </svg>
    <span className={`${c}__zzz`}>
      <i>z</i>
      <i>z</i>
      <i>Z</i>
    </span>
  </span>
)

const StatusPill = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation()
  const { isOpen, minTime, maxTime } = useStoreHours()

  return (
    <button
      type='button'
      className={`${c} ${isOpen ? 'is-open' : 'is-closed'}`}
      onClick={onClick}
      title={`${minTime} – ${maxTime}`}
    >
      {isOpen ? (
        <span className={`${c}__dot`} />
      ) : (
        <SleepingPanda />
      )}
      <span className={`${c}__label`}>
        {isOpen ? t('OPEN_NOW') : t('CLOSED_NOW')}
      </span>
      <span className={`${c}__hours`}>
        {minTime}–{maxTime}
      </span>
      {onClick && <FontAwesomeIcon icon={faChevronDown} className={`${c}__more`} />}
    </button>
  )
}

export default StatusPill
